import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import error403src from '@classify/illustrations/error403';
import { ImageCdn } from '@openclassrooms/images-cdn';
import ErrorWrapper, { Props } from './ErrorWrapper';
const Error403 = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    const {
      pictureUrl,
      pictureWidth,
      ...t1
    } = t0;
    props = t1;
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ImageCdn alt="" src={error403src} width={450} height={277} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const pictureElement = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translate("errors.error403.title");
    t3 = translate("errors.error403.subtitle");
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props) {
    t4 = <ErrorWrapper httpStatus={403} hasButton={true} pictureElement={pictureElement} titleLabel={t2} detailsLabel={t3} {...props} />;
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default Error403;